import React from 'react';
import { useParams } from 'react-router-dom';
import ResourceHub from '../components/resourceHub/ResourceHub';

export enum HubIdentifier {
	PROVIDERS_EDUCATORS = 'providers-educators',
	ACCREDITATION_MAINTENANCE = 'accreditation-maintenance',
}

export type ResourceHubPageProps = {
	className?: string;
};

export default function ResourceHubPage(props: ResourceHubPageProps) {
	const { className } = props;

	const { hubIdentifier } = useParams<{ hubIdentifier: string }>();

	if (!hubIdentifier || !Object.values(HubIdentifier).includes(hubIdentifier as HubIdentifier)) {
		return <div>Error: Invalid Resource Hub Identifier.</div>;
	}

	return <ResourceHub className={className} hubIdentifier={hubIdentifier} />;
}
